(function () {
  'use strict';

  /* @ngdoc object
   * @name bmfexport
   * @description
   *
   */
  angular
    .module('vcfinance.rksv', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
